import { Routes, Route, Navigate, Outlet } from "react-router-dom";
import Layout from "./Layout";
import AgentsPage from "../modules/agents/pages/AgentsPage";
import AgentDetailPage from "../modules/agents/pages/AgentDetailPage";
import Dashboard from "../modules/dashboard/pages/Dashboard";
import Inbox from "../modules/inbox/pages/Inbox";
import FunnelPage from "../modules/inbox/pages/Funnel";
import Channels from "../modules/channels/pages/Channels";
import Contacts from "../modules/contacts/pages/Contacts";
import Users from "../modules/users/pages/Users";
import Subscription from "../modules/subscription/pages/Subscription";
import Login from "../modules/authentication/pages/Login";
import Register from "../modules/authentication/pages/Register";
import PasswordRecovery from "../modules/authentication/pages/PasswordRecovery";
import ResetPassword from "../modules/authentication/pages/ResetPassword";
import { WorkflowsPage, WorkflowEditorPage } from "../modules/workflows";
import { useAuth } from "../context/AuthContext";
import { Loader2 } from "lucide-react";

export default function RoutesApp() {
    const { isAuthenticated, isLoading } = useAuth();

    if (isLoading) {
        return (
            <div className="flex items-center justify-center h-screen bg-gray-50">
                <Loader2 className="h-8 w-8 animate-spin text-primary" />
            </div>
        );
    }

    return (
        <Routes>
            {/* Auth pages: if authenticated, redirect to dashboard */}
            <Route path="/login" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Login />} />
            <Route path="/register" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <Register />} />
            <Route path="/password-recovery" element={isAuthenticated ? <Navigate to="/dashboard" replace /> : <PasswordRecovery />} />
            <Route path="/reset-password" element={<ResetPassword />} />

            {/* Protected app pages: if not authenticated, redirect to login */}
            <Route element={<Layout><Outlet /></Layout>}>
                <Route path="/" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />} />
                <Route path="/dashboard" element={isAuthenticated ? <Dashboard /> : <Navigate to="/login" replace />} />
                <Route path="/workflows" element={isAuthenticated ? <WorkflowsPage /> : <Navigate to="/login" replace />} />
                <Route path="/workflows/:id" element={isAuthenticated ? <WorkflowEditorPage /> : <Navigate to="/login" replace />} />
                <Route path="/agents" element={isAuthenticated ? <AgentsPage /> : <Navigate to="/login" replace />} />
                <Route path="/agents/:id" element={isAuthenticated ? <AgentDetailPage /> : <Navigate to="/login" replace />} />
                <Route path="/inbox" element={isAuthenticated ? <Inbox /> : <Navigate to="/login" replace />} />
                <Route path="/funnel" element={isAuthenticated ? <FunnelPage /> : <Navigate to="/login" replace />} />
                <Route path="/channels" element={isAuthenticated ? <Channels /> : <Navigate to="/login" replace />} />
                <Route path="/contacts" element={isAuthenticated ? <Contacts /> : <Navigate to="/login" replace />} />
                <Route path="/users" element={isAuthenticated ? <Users /> : <Navigate to="/login" replace />} />
                <Route path="/subscription" element={isAuthenticated ? <Subscription /> : <Navigate to="/login" replace />} />
            </Route>
            {/* Catch-all: redirect to dashboard if authenticated, else login */}
            <Route path="*" element={<Navigate to={isAuthenticated ? "/dashboard" : "/login"} replace />} />
        </Routes>
    );
}
